import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { useEffectOnce } from 'react-use'
import config, { environment } from '../config'

interface Props {
  children: React.ReactNode
}

export default function DataDogProvider({ children }: Readonly<Props>) {
  useEffectOnce(() => {
    if (config.datadogAppId && !datadogRum.getInitConfiguration()) {
      datadogRum.init({
        applicationId: config.datadogAppId,
        clientToken: config.datadogClientToken,
        site: 'us5.datadoghq.com',
        service: 'photobucket-webapp',
        env: environment,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        defaultPrivacyLevel: 'mask-user-input',
        trackBfcacheViews: true,
        // used to track route changes
        plugins: [reactPlugin({ router: true })],
        // initalize RUM SKD
        allowedTracingUrls: [{ match: /^https:\/\/([^\\/]+\.)?photobucket\.com\//, propagatorTypes: ['tracecontext', 'datadog'] }],
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true
      })

      // Datatdog console logs
      datadogLogs.init({
        clientToken: config.datadogClientToken,
        site: 'us5.datadoghq.com',
        forwardErrorsToLogs: true,
        forwardConsoleLogs: 'all',
        sessionSampleRate: 100
      })
    }
  })

  return <>{children}</>
}
